import AssignmentIcon from '@mui/icons-material/Assignment';
import { Box, Container, Grid, Link, Typography } from '@mui/material';
import Cookies from 'js-cookie';
import { isEmpty } from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import AuthWrapper from 'src/components/AuthWrapper';
import RegionStepper from 'src/components/RegionStepper';
import SecondRegionStepper from 'src/components/stepper/SecondRegionStepper';
import ThinkSkillsHeader from 'src/components/ThinkSkillsHeader';
import { getRegionBySlug } from './CareerHistory/CareerHistorySlice';
import { ArcticonsEmojiSpiderWeb } from './Reskill_Flow/SpiderIcon';

const UpskillCollegesPageRegion = () => {
  const colleges = [
    {
      name: 'Heart of Worcestershire College (HoW College)',
      description: `We have a wide range of full and part-time courses in a variety of different subject areas; 
      from Engineering, Accounting and Marketing, to NVQs, ESOL and Teacher Training, the possibilities are endless.
  
      Whether you’re looking to progress your career, learn a new skill or try a new hobby, we have a course for you.`,
      location: 'Various',
      website: 'www.linktocollegewebsite.org.uk',
    },
    {
      name: 'Kidderminster College',
      description: `It's always possible to make a change. Whether you're considering a career shift, planning to rejoin the workforce, 
      or aiming to develop the skills to kickstart your business venture, Kidderminster College is here for you. 
      We offer various part-time courses tailored to empower adults like you in their educational journey. 
      Make a fresh start with Kidderminster College and embrace the opportunities that await you.`,
      location: 'Market Street, Kidderminster, DY10 1AB',
      website: 'www.linktocollegewebsite.org.uk',
    },
    {
      name: 'College group WCG',
      description: `From part-time leisure courses to professional qualifications including degrees, 
      we have something for everyone at WCG.
  
      We know that our range of lifelong learning programmes is essential to strengthening our communities and 
      making sure that local people can succeed in their personal goals and career aspirations.`,
      location: 'Various',
      website: 'www.linktocollegewebsite.org.uk',
    },
  ];
  const params = useParams();
  const isRegion = !!params?.rg_name;
  const stepperSteps = useMemo(
    () => [
      {
        label: 'Your Skills',
        link: isRegion
          ? `/region/${params.rg_name}/upskill/skilldar`
          : `/${params.cg_name}/upskill/skilldar`,
      },
      {
        label: 'Your Careers',
        link: isRegion
          ? `/region/${params.rg_name}/upskill/career-courses`
          : `/${params.cg_name}/upskill/career-courses`,
      },
      {
        label: 'Colleges',
        link: isRegion
          ? `/region/${params.rg_name}/upskill/colleges`
          : `/${params.cg_name}/upskill/colleges`,
      },
      {
        label: 'Your Region',
        link: isRegion
          ? `/region/${params.rg_name}/upskill/regional-info`
          : `/${params.cg_name}/upskill/regional-info`,
      },
    ],
    [params, isRegion]
  );
  const [regionData, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const { rg_name } = useParams();
  const buttonColor = regionData?.button?.bgColor;
  const buttonFontColor = regionData?.button?.color;
  const dispatch = useDispatch();
  const regions = useSelector((state) => state.careerHistory);
  const logo = regionData?.logo || '';
  const partnerLogos = regionData?.partnerLogos || [];
  const primaryColor = regionData?.primaryColor || '';
  const fontColor = regionData?.fontColor || '';
  const secondaryColor = regionData?.secondary;
  const bgImage = regionData?.bgImage || '';
  const steps = [
    { icon: <AssignmentIcon />, label: 'Career History' },
    {
      icon: <ArcticonsEmojiSpiderWeb width={36} height={36} color={buttonFontColor} />,
      label: 'Results',
    }, // Capitalized if it's a component
  ];
  useEffect(() => {
    if (rg_name) {
      Cookies.set('url-slug', rg_name);
    }
  }, [rg_name]);
  useEffect(() => {
    setLoading(true);
    dispatch(getRegionBySlug(rg_name));
  }, [rg_name, dispatch]);

  useEffect(() => {
    if (regions?.regions) {
      setData(regions?.regions);
      if (!isEmpty(regionData)) {
        setLoading(false);
      }
    }
  }, [regions?.regions, regionData]);

  return (
    <>
      <AuthWrapper title="Colleges">
        <Box
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            minHeight: '100vh',
            backgroundAttachment: 'fixed',
          }}
          className="page-content-wrapper"
        >
          <Container maxWidth="xl">
            <Box mb={0.2} className="content">
              <ThinkSkillsHeader fontColor="white" />
              <Box pb={2}>
                <RegionStepper
                  steps={steps}
                  activeStep={1} // Change to 1 to highlight "Results"
                  buttonColor={buttonColor}
                  buttonFontColor={buttonFontColor}
                />
              </Box>
              <SecondRegionStepper steps={stepperSteps} activeStep={2} noIcon />
            </Box>
            <Box sx={{ backgroundColor: 'white', p: 2 }}>
              <Typography sx={{ fontSize: '22px !important' }} textAlign="start">
                Local Colleges Supporting Your Journey
                <span
                  style={{
                    fontSize: '16px',
                    textAlign: 'start',
                    marginTop: '6px',
                    fontWeight: 300,
                  }}
                >
                  Thinkskills is supported by local colleges who share one goal: helping people and
                  businesses across Worcestershire gain the skills needed to thrive today and
                  tomorrow. Together, they provide the training, courses, and guidance you need to
                  upskill, reskill, and take the next step in your career.
                </span>
              </Typography>
              <Grid container spacing={4} mt={1}>
                {colleges.map((college, index) => (
                  <Grid item xs={12} md={4} key={index}>
                    <Box sx={{ textAlign: 'center' }}>
                      {/* Image placeholder */}
                      {/* <Box
                                                sx={{
                                                    width: '100%',
                                                    height: 180,
                                                    bgcolor: '#ccc',
                                                    mb: 2,
                                                }}
                                            /> */}

                      <Box
                        component="img"
                        src={`https://picsum.photos/400/180?random=${index}`} // Unique per card
                        alt={college.name}
                        sx={{
                          width: '100%',
                          height: 180,
                          objectFit: 'cover',
                          borderRadius: 1,
                          mb: 2,
                        }}
                      />

                      <Typography
                        sx={{ fontSize: '22px !important', fontWeight: 700 }}
                        gutterBottom
                      >
                        {college.name}
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: '16px !important',
                          fontWeight: 400,
                          textAlign: 'left',
                          whiteSpace: 'pre-line',
                        }}
                      >
                        {college.description}
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: '16px !important',
                          fontWeight: 400,
                          textAlign: 'left',
                          whiteSpace: 'pre-line',
                          mt: 1,
                        }}
                      >
                        <strong>Location:</strong> {college.location}
                      </Typography>

                      <Link
                        href={`${college.website}`}
                        target="_blank"
                        underline="hover"
                        sx={{ display: 'block', mt: 1, textAlign: 'left' }}
                      >
                        {college.website}
                      </Link>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Container>
        </Box>
      </AuthWrapper>
    </>
  );
};

export default UpskillCollegesPageRegion;
